import Skeleton from "./Skeleton";
import SkeletonGrid from "./SkeletonGrid";
import styles from "./Skeleton.module.scss";

type Props = {
  cardHeight?: number;
  minCardWidth?: number;
};

const PageSkeleton = ({ cardHeight = 210, minCardWidth = 160 }: Props) => (
  <div className={styles.page} aria-busy>
    <Skeleton radius={12} className={styles.pageBanner} />
    <Skeleton width={180} height={20} radius={999} />
    <SkeletonGrid count={8} cardHeight={cardHeight} minCardWidth={minCardWidth} />
  </div>
);

export default PageSkeleton;
